export const normalizeInviteesResponse = (inviteesData) => {
  if (!inviteesData) {
    return {
      results: [],
      pagination: { totalCount: 0, currentPage: 1, nextPage: false },
    }
  }

  if (Array.isArray(inviteesData)) {
    return {
      results: inviteesData,
      pagination: { totalCount: inviteesData.length, currentPage: 1, nextPage: false },
    }
  }

  return {
    results: inviteesData.results ?? [],
    pagination: inviteesData.pagination ?? {
      totalCount: (inviteesData.results || []).length,
      currentPage: 1,
      nextPage: false,
    },
  }
}
